(function () {
  const SCHEDULE_TEXT = 'Schedule Your Time';
  const ADD_TO_CART_TEXT = 'Add to Cart';
  const IGNORE_STATES = ['loading', 'adding', 'added', 'view cart', 'processing'];

  function getCheckbox() { return document.getElementById('fitting-checkbox'); }
  function getAppointoBtn() { return document.getElementById('appointo-btn'); }
  function isFittingChecked() { const cb = getCheckbox(); return cb ? cb.checked : false; }

  function shouldIgnore(text) {
    const lower = (text || '').toLowerCase().trim();
    return IGNORE_STATES.some(s => lower.includes(s));
  }

  function updateButton() {
    const btn = getAppointoBtn();
    if (!btn) return;
    const currentText = (btn.textContent || '').trim();
    if (shouldIgnore(currentText)) return;
    const expected = isFittingChecked() ? SCHEDULE_TEXT : ADD_TO_CART_TEXT;
    if (currentText !== expected) btn.textContent = expected;
  }

  // Intercept clicks
  document.addEventListener('click', function (e) {
    const btn = getAppointoBtn();
    if (!btn || (!btn.contains(e.target) && e.target !== btn)) return;

    if (!isFittingChecked()) {
      e.stopImmediatePropagation();
      e.preventDefault();
      const variantId = document.querySelector('input[name="id"]')?.value;
      if (variantId) {
        btn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(r => r.json())
        .then(() => {
          btn.textContent = '✓ Added to Cart';
          document.dispatchEvent(new CustomEvent('cart:updated'));
          setTimeout(() => { btn.textContent = ADD_TO_CART_TEXT; }, 2500);
        })
        .catch(() => { btn.textContent = ADD_TO_CART_TEXT; });
      }
    }
    // Fitting ticked — let Appointo handle
  }, true);

  // Checkbox change
  document.addEventListener('change', function (e) {
    if (e.target.id === 'fitting-checkbox') setTimeout(updateButton, 100);
  });

  // Variant change
  document.addEventListener('variant:changed', function () { setTimeout(updateButton, 200); });

  // Watch ONLY #appointo-btn for text changes by Appointo
  function watchAppointoBtn() {
    const btn = getAppointoBtn();
    if (!btn) return;

    new MutationObserver(function () {
      const currentText = (btn.textContent || '').trim();
      if (!shouldIgnore(currentText)) {
        const expected = isFittingChecked() ? SCHEDULE_TEXT : ADD_TO_CART_TEXT;
        if (currentText !== expected) btn.textContent = expected;
      }
    }).observe(btn, { childList: true, characterData: true, subtree: true });
  }

  // Init — wait for Appointo to inject its button, then lock it down
  function init() {
    const btn = getAppointoBtn();
    if (btn) {
      updateButton();
      watchAppointoBtn();
    } else {
      // Button not ready yet — watch for it to appear
      const bodyObserver = new MutationObserver(function () {
        if (getAppointoBtn()) {
          bodyObserver.disconnect();
          updateButton();
          watchAppointoBtn();
        }
      });
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    }
  }

  window.addEventListener('load', function () { setTimeout(init, 500); });

})();
